import { Heading } from '@finviz/website'
import React from 'react'

import { Theme } from '../../../../types/shared'
import { ChartEventBadgeType, ChartEventLabels } from '../../../constants/common'
import { CHART_EVENT_BADGE_SIZE } from '../../../models/constants'
import {
  ChartEventBadgeState,
  IDividends,
  getFormattedEventDate,
  getFormattedValue,
} from '../../../utils/chart-events-utils'
import { getChartEventBadgeElement } from '../badges/get-chart-event-badge-element'
import { ChartEventPopoverTableRow, PopoverTableRowData } from './chart-event-popover-table-row'

export function ChartEventDividendsPopoverContent({
  badgeType,
  rawData,
  theme,
}: {
  badgeType: ChartEventBadgeType
  rawData: IDividends
  theme: Theme
}) {
  const data = React.useMemo(() => {
    const dataArray: PopoverTableRowData[] = [
      [{ value: 'Ex-date' }, { value: getFormattedEventDate(rawData.dateTimestamp) }],
    ]
    if (rawData.ordinary > 0) {
      dataArray.push([
        { value: 'Amount' },
        { value: getFormattedValue({ value: rawData.ordinary }), className: 'tabular-nums' },
      ])
    }
    if (rawData.special > 0) {
      dataArray.push([
        { value: 'Special' },
        { value: getFormattedValue({ value: rawData.special }), className: 'tabular-nums' },
      ])
    }
    return dataArray
  }, [rawData])

  return (
    <>
      <div className="mb-3 flex space-x-1.5">
        {getChartEventBadgeElement({
          theme: theme,
          state: ChartEventBadgeState.default,
          width: CHART_EVENT_BADGE_SIZE,
          badgeType,
        })}{' '}
        <Heading level={4} className="my-0 text-base">
          {ChartEventLabels[badgeType]}
        </Heading>
      </div>
      <table>
        <tbody>
          {data.map((item, index) => (
            <ChartEventPopoverTableRow data={item} key={`${index}-${item[0]}`} />
          ))}
        </tbody>
      </table>
    </>
  )
}
